module.exports = __webpack_public_path__ + "static/media/TeamsAssets-Regular.de8a9eb1.svg";